/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

function notify(data) {
  const title = data.title ?? null;
  const description = data.description ?? null;
  const timeout = 3000;

  const body = document.querySelector("body");
  let container = body.querySelector(".notify-container");

  if (container === null) {
    container = document.createElement("div");
    container.setAttribute(
      "class",
      "notify-container tw-fixed tw-top-8 tw-right-8 tw-z-[500] tw-space-y-4",
    );
    body.appendChild(container);
  }

  const notifyNode = document.createElement("div");
  notifyNode.setAttribute(
    "class",
    "tw-text-white tw-text-sm tw-bg-[#0071CE] tw-rounded-lg tw-flex tw-justify-between tw-items-center tw-px-5 tw-py-4 lg:tw-w-96 tw-cursor-pointer",
  );
  notifyNode.addEventListener("click", (e) => {
    notifyNode.remove();
  });

  const notifyContentNode = document.createElement("div");
  notifyContentNode.setAttribute("class", "");

  const notifyCloseNode = document.createElement("div");
  notifyCloseNode.setAttribute("class", "tw-flex");
  notifyCloseNode.innerHTML =
    "" +
    '<svg xmlns="http://www.w3.org/2000/svg" class="tw-w-4 tw-ml-5" viewBox="0 0 16 16">\n' +
    '  <path id="Path_7559" data-name="Path 7559" d="M81.862,80.75a1.111,1.111,0,0,0-.785,1.9l6.1,6.1-6.1,6.1a1.111,1.111,0,1,0,1.571,1.571l6.1-6.1,6.1,6.1a1.111,1.111,0,0,0,1.571-1.571l-6.1-6.1,6.1-6.1a1.111,1.111,0,0,0-1.571-1.571l-6.1,6.1-6.1-6.1A1.107,1.107,0,0,0,81.862,80.75Zm0,0" transform="translate(-80.751 -80.75)" fill="#fff"/>\n' +
    "</svg>\n" +
    "";

  const titleNode = document.createElement("div");
  titleNode.setAttribute("class", "tw-font-medium");
  titleNode.innerHTML = title;
  notifyContentNode.appendChild(titleNode);

  const descriptionNode = document.createElement("div");
  descriptionNode.setAttribute("class", "");
  descriptionNode.innerHTML = description;
  notifyContentNode.appendChild(descriptionNode);

  notifyNode.appendChild(notifyContentNode);
  notifyNode.appendChild(notifyCloseNode);

  container.appendChild(notifyNode);

  setTimeout(() => notifyNode.remove(), timeout);
}

export default notify;
